export const Api_url = "https://elydor.net";
